import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import Button from 'components/form/Button';
import useUserStore from 'state/userStore';
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);

  const { user } = useUserStore();

  const toggleModal = () => {
    setSidebar(!sidebar);
  };

  const navigateFunc = (route: string) => {
    navigate(route);
    toggleModal();
  };

  return (
    <nav className="relative z-50 mb-[65px]">
      <div className="fixed top-0 left-0 right-0 bg-slate-100">
        <div className="container mx-auto flex justify-between p-4">
          <Link to="/" className="my-auto">
            <div className="flex items-end gap-x-1">
              <div className="h-[50px] w-[50px]">
                <img
                  src="/assets/logo.png"
                  alt="app-logo"
                  className="h-full w-full object-cover"
                />
              </div>

              <p className="mb-1 font-mono text-xl font-bold">Blockchain</p>
            </div>
          </Link>
          <div className="my-auto hidden gap-x-5 md:flex">
            <Link to="/">
              <p className="hover:border-b hover:border-blue-500 hover:text-blue-500">
                Home
              </p>
            </Link>
            <HashLink to="/#services">
              <p className="hover:border-b hover:border-blue-500 hover:text-blue-500">
                Services
              </p>
            </HashLink>
            <Link to="/contact">
              <p className="hover:border-b hover:border-blue-500 hover:text-blue-500">
                Contact Us
              </p>
            </Link>
            <Link to="/about">
              <p className="hover:border-b hover:border-blue-500 hover:text-blue-500">
                About
              </p>
            </Link>
          </div>
          {user ? (
            <Link to={user?.type === 'admin' ? '/admin' : '/dashboard'}>
              <p className="rounded-md border bg-blue-500 px-5 py-2 text-white">
                Dashboard
              </p>
            </Link>
          ) : (
            <div className="hidden gap-x-5 md:flex">
              <Link to="/login">
                <p className="rounded-md border border-blue-500 px-5 py-2 hover:bg-blue-500 hover:text-white">
                  Login
                </p>
              </Link>
              <Link to="/register">
                <p className="rounded-md border bg-blue-500 px-5 py-2 text-white">
                  Sign up
                </p>
              </Link>
            </div>
          )}

          <div className="my-auto md:hidden">
            {!sidebar ? (
              <div onClick={() => toggleModal()}>
                <AiOutlineMenu className="text-3xl" />
              </div>
            ) : (
              <div onClick={() => toggleModal()}>
                <AiOutlineClose className="text-3xl" />
              </div>
            )}
          </div>
        </div>
      </div>
      {sidebar && (
        <div className="fixed top-[78px] left-0 right-0 h-screen bg-white md:hidden">
          <div className="container mx-auto flex flex-col justify-between gap-y-5 p-6">
            <div className="flex flex-col gap-y-5">
              <Button onClick={() => navigateFunc('/')} className="text-left">
                <p className="text-2xl hover:border-b hover:border-blue-500 hover:text-blue-500">
                  Home
                </p>
              </Button>
              <HashLink to="/#services" onClick={() => toggleModal()}>
                <p className="px-3 text-2xl hover:border-b hover:border-blue-500 hover:text-blue-500">
                  Services
                </p>
              </HashLink>
              <Button
                onClick={() => navigateFunc('/contact')}
                className="text-left"
              >
                <p className="text-2xl hover:border-b hover:border-blue-500 hover:text-blue-500">
                  Contact Us
                </p>
              </Button>
              <Button
                onClick={() => navigateFunc('/about')}
                className="text-left"
              >
                <p className="text-2xl hover:border-b hover:border-blue-500 hover:text-blue-500">
                  About
                </p>
              </Button>
            </div>
            {user ? (
              <Button
                className="rounded-md border border-blue-500 px-5 py-2"
                onClick={() => navigateFunc('/dashboard')}
              >
                Dashboard
              </Button>
            ) : (
              <div className="flex flex-col gap-y-5">
                <Button
                  className="rounded-md border border-blue-500 px-5 py-2"
                  onClick={() => navigateFunc('/login')}
                >
                  Login
                </Button>
                <Button
                  className="rounded-md bg-blue-500 px-5 py-2 text-white"
                  onClick={() => navigateFunc('/register')}
                >
                  Sign up
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
